import type { ConnectError } from '@connectrpc/connect'
import {
  PlantMasterErrorReason,
  PlantMasterErrorReasonSchema,
} from '@ebalance/proto/bffuser/v1/occto_master_model_pb'
import type { TFunction } from 'i18next'

import {
  type AppErrorInfoReasonEntry,
  type AppErrorInfoResolution,
  resolveAppErrorInfoMessage,
} from '~/libs/appErrorInfo'

/**
 * `PlantMasterErrorReason` (occto-plant-business-master-reason-registry
 * 設計書、backend `occtomaster` domain) → i18n key + field routing registry
 * for the PlantMaster Create/Update modals (BgMaster/SubmitterMaster と同型)。
 *
 * `MEMBER_BUSINESS_MASTER_NOT_FOUND` has no `field` (Design Note D3:
 * members is a list and the missing member's index does not surface on
 * the wire, so a field-scoped mapping would misattribute the error when a
 * non-representative member is the one missing) — it resolves to the
 * top-level alert (operation-scoped).
 */
const PLANT_MASTER_REASON_KEYS: Record<
  PlantMasterErrorReason,
  AppErrorInfoReasonEntry | undefined
> = {
  [PlantMasterErrorReason.UNSPECIFIED]: undefined,
  [PlantMasterErrorReason.PLANT_CODE_INVALID_FORMAT]: {
    key: 'page:adminOcctoMaster.serverError.reason.plantCodeInvalidFormat',
    field: 'plantCode',
  },
  [PlantMasterErrorReason.MEMBER_BUSINESS_MASTER_NOT_FOUND]: {
    key: 'page:adminOcctoMaster.serverError.reason.businessMasterNotFound',
  },
}

/**
 * `resolveDetailedError` for PlantMaster's `useCrudModalForm` (Create /
 * Update). Resolves the `google.rpc.ErrorInfo` Connect error detail, if
 * any, against `PLANT_MASTER_REASON_KEYS` via the
 * `PlantMasterErrorReasonSchema` reflection lookup.
 */
export function resolvePlantMasterDetailedError(
  err: ConnectError,
  t: TFunction,
): AppErrorInfoResolution | undefined {
  return resolveAppErrorInfoMessage(
    err,
    PlantMasterErrorReasonSchema,
    PLANT_MASTER_REASON_KEYS,
    t,
  )
}
